import '../../styles-new/pages/article.scss';
// import "../../styles-new/blocks/shared/share-btn.scss";
// import "../../styles-new/blocks/shared/breadcrumbs.scss";

import '../components/article-image-slider';

import generateTabs from '../components/generateTabs';
import '../components/adult-content';
import '../components/share-btn';
import { initializeArticlePopup } from '../components/images-popup';
// import { initProgressBar } from '../components/progress-bar';
import '../components/amp-stories/slider';
generateTabs('sidebar-last', { isLoadMore: false });

document.addEventListener('DOMContentLoaded', () => { 
  initializeArticlePopup();

  //handle show catfish banner
  const catfishAdElem = document.querySelector('.catfish-ad');
  const bottomNavbarElem = document.querySelector('.bottom-navbar');

  const handleScroll = () => {
    const currentScrollPos = window.pageYOffset;

    if (currentScrollPos > 860) {
      catfishAdElem.classList.add('catfish-ad_active');
      bottomNavbarElem.dataset.bannerLoaded = true
      if(bottomNavbarElem.classList.contains('bottom-navbar_opened') || bottomNavbarElem.classList.contains('bottom-navbar_opened-with-cookies')) {
        bottomNavbarElem.classList.add('bottom-navbar_opened-with-banner');
      }
      window.removeEventListener('scroll', handleScroll);
    }
  }

  if(catfishAdElem && bottomNavbarElem) {
    window.addEventListener('scroll', handleScroll);
  }
});

const actualItemsPlaceholder = document.querySelector('.actual__items');
const sidebarsPlaceholder = document.querySelectorAll('.sidebar-popular-tab-content');
const getData = async () => {
  let placeholders = document.querySelectorAll('.read-more-slider-placeholder');
  let readMoreSliderPlaceholder = placeholders[placeholders.length - 1];

  let url = `/${window.postData.lang === 'uk' ? '' : window.postData.lang + '/'}load-post-additional-data/?postId=${window.postData.id}&theme=${window.postData.theme}`;
  // debugger;

  try {
    const response = await fetch(url);
    let html;
    if (response.ok) {
      html = await response.text();
    }
    const data = html.split('$*');
    if (readMoreSliderPlaceholder) {
      readMoreSliderPlaceholder.innerHTML = data[0];
    }

    if (actualItemsPlaceholder) {
      actualItemsPlaceholder.innerHTML = data[1];
    }
    if (sidebarsPlaceholder.length >= 1) {
      if (sidebarsPlaceholder[1])
        sidebarsPlaceholder[1].innerHTML = data[2];
      if (sidebarsPlaceholder[2])
        sidebarsPlaceholder[2].innerHTML = data[3];
      if (sidebarsPlaceholder[3])
        sidebarsPlaceholder[3].innerHTML = data[4];
    }

    // TODO: This code is repeated in base.html
    readMoreSliderPlaceholder?.querySelectorAll('img').forEach(itm => itm.hasAttribute("data-src") && itm.classList.add('lazy'));
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));

    if ("IntersectionObserver" in window) {
      let lazyImageObserver = new IntersectionObserver(function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            let lazyImage = entry.target;
            lazyImage.src = lazyImage.dataset.src;
            lazyImage.classList.remove("lazy");
            lazyImageObserver.unobserve(lazyImage);
          }
        });
      });

      lazyImages.forEach(function (lazyImage) {
        lazyImageObserver.observe(lazyImage);
      });
    }

  } catch (error) {
    console.log(error);
  }
}

window.getData = getData;

if (window.postData) {
  window.addEventListener('load', getData);
}

window.calculateSidebarsHeights = (articleWrapper) => {
  const h1Title = articleWrapper.querySelector('h1');
  const mainImage = articleWrapper.querySelector('.content__main-image');
  const advSidebars = articleWrapper.querySelector(".adv-sidebars");
  if (!advSidebars) return;
  const [stickyBlock1, stickyBlock2, stickyBlock3] = advSidebars.querySelectorAll('.adv-sidebars__docked');

  // Calculating height of the first sticky block
  // 40px - top padding
  // 30px - top-line (share/date/socials)
  // advertisement height - 628px
  // error margin - 15px
  // margin-bottom adv - 25px
  const firstSidebarHeight = 40 + h1Title.clientHeight + mainImage.clientHeight + 30 + 628 + 25 - 15;

  // for smaller banner we need to reduce the height of the first sidebar
  const delim = stickyBlock2.querySelector('ins').dataset.isbig ? 1.25 : 2.1;

  const secondSidebarHeight = firstSidebarHeight / delim;
  stickyBlock1.style.height = `${firstSidebarHeight}px`;
  stickyBlock2.style.height = `${secondSidebarHeight}px`;
  stickyBlock3.style.height = `calc(100% - ${firstSidebarHeight + secondSidebarHeight}px)`;

  return [stickyBlock1, stickyBlock2, stickyBlock3]
}

window.calculateSidebarsHeights(document.querySelector('.article-wrapper'));

window.addEventListener('DOMContentLoaded', () => {
  const faqItems = document.querySelectorAll(".article-faq__item");

  faqItems.forEach(item => {
    const head = item.querySelector(".article-faq__head");

    head.addEventListener("click", () => {
      // Toggle the 'active' class on the item
      item.classList.toggle("active");
    });
  });

})

// window.addEventListener('scroll', handleStickySidebars)



// // Initialize progress bar when DOM is loaded
// window.addEventListener('DOMContentLoaded', () => {
//   initProgressBar();
//   window.initProgressBar = initProgressBar;
// });